import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { SignIn, SignUp, ClerkLoading, ClerkFailed } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { AuthLoading, AuthFailed } from "@/components/auth/AuthStatus";
import AgeGate from "@/components/AgeGate";
import CookieBanner from "@/components/legal/CookieBanner";
import Landing from "@/pages/Landing";
import Chat from "@/pages/Chat";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { usePageTracking } from "@/hooks/usePageTracking";

const AuthShell = ({ children }) => (
  <div className="grain min-h-screen flex items-center justify-center p-4">
    <ClerkLoading><AuthLoading /></ClerkLoading>
    <ClerkFailed><AuthFailed /></ClerkFailed>
    {children}
  </div>
);

const PageTracker = () => {
  usePageTracking();
  return null;
};

// Clerk only loads on admin pages, so regular visitors get no auth cookies.
const ClerkLayout = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <AgeGate />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/aszf" element={<Terms />} />
          <Route path="/adatvedelem" element={<Privacy />} />
          <Route element={<ClerkLayout />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp forceRedirectUrl="/admin" /></AuthShell>} />
            <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl="/admin" /></AuthShell>} />
          </Route>
        </Routes>
        <CookieBanner />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
